<template>
  <div id="app">
    <header>
      <h1>???</h1>
    </header>

    <Board ref="board" v-show="playing" @restart="restart" />
    <OptionsPane ref="optionsPane" @gameStart="start" v-show="!playing" />

  </div>
</template>

<script>
import Board from './components/Board'
import OptionsPane from './components/OptionsPane'
import loadImage from 'blueimp-load-image'

export default {
  name: 'app',
  components: {
    Board,
    OptionsPane
  },

  data () {
    return {
      playing: false,
      image: null
    }
  },

  methods: {
    start (...args) {
      this.playing = true
      this.$refs.board.start({
        image: this.image,
        size: {
          horizontal: 3,
          vertical: 3
        }
      })
    },

    restart () {
      this.playing = false
      this.$refs.optionsPane.reset()
    }
  },

  mounted () {
    loadImage('/static/heart.jpg', canvas => {
      this.image = canvas.toDataURL()
    }, {
      maxWidth: 600,
      maxHeight: 600,
      minWidth: 200,
      minHeight: 200,
      canvas: true
    })

    // this.start({
    //   image: this.image,
    //   size: {
    //     horizontal: 3,
    //     vertical: 3
    //   }
    // })
  }
}
</script>

<style lang="scss">
*, *::before, *::after {
  box-sizing: border-box;
}

a {
  text-decoration: none;
  color: #368ba0;
}

#app {
  font: 14px/20px sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  header {
    h1 {
      font-weight: 100;
      height: 80px;
      line-height: 80px;
      font-size: 38px;
    }
  }

  footer {
    color: #555;
    margin-top: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?9d1c6530